var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoMotorEmbraiagem2Pt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "29px",
    viewBox: "0 0 38 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Motor e embraiagem &gt; 2pt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS-CATEGORIES",
    transform: "translate(-123.000000, -403.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Motor-e-embraiagem->-2pt",
    transform: "translate(124.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "33.941119 8.34171386 31.1235494 8.34171386 31.1235494 11.4005746 27.2724608 11.4005746 27.2724608 8.34171386 22.8581316 8.34171386 22.8581316 6.02440873 22.8581316 3.7075533 7.64289114 3.7075533 7.64289114 6.02440873 3.75671392 6.02440873 3.75671392 22.0170969 7.64289114 22.0170969 9.94825823 22.0170969 14.4054228 26.4156146 27.2724608 26.4156146 27.2724608 22.0170969 31.1235494 22.0170969 31.1235494 25.0251416 33.941119 25.0251416 35.8194987 20.761534 35.8194987 12.420045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,21.5284977 L0,6.51345769",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64289114,-4.49700201e-05 L22.8581316,-4.49700201e-05",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2506025,-4.49700201e-05 L15.2506025,3.70728348",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14.0208877 L3.75675949,14.0208877",
    id: "Stroke-9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoMotorEmbraiagem2Pt);
export default __webpack_public_path__ + "static/media/PictoMotorEmbraiagem_2pt.71496178c6321be5e7375151fae0dbc6.svg";
export { ForwardRef as ReactComponent };